
import { toast } from "sonner";

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export const blobStorageService = {
  async getImageUrl(blobName, containerName = "domains") {
    try {
      if (!blobName) {
        // console.warn("Aucun blobName fourni");
        return null;
      }

      const response = await fetch(
        `${API_BASE_URL}/api/BlobStorage/generate-sas-url/${encodeURIComponent(blobName)}/${containerName}`
      );
      // console.log(`Récupération de l'URL SAS pour ${blobName} dans ${containerName}:`, response);

      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status}`);
      }

      const data = await response.json();
      return data.url;
    } catch (error) {
      console.error("Erreur lors de la récupération de l'URL SAS:", error);
      return null;
    }
  },

  // Uploader une image
  async uploadImage(file, containerName = "domains") {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await fetch(
        `${API_BASE_URL}/api/BlobStorage/upload/${containerName}`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        throw new Error(`Erreur upload: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      // console.error("Erreur lors de l'upload:", error);
      toast.error("Erreur lors de l'upload de l'image");
      throw error;
    }
  }
};



// Export nommé supplémentaire pour compatibilité
export const getSasUrl = blobStorageService.getImageUrl;